import styled from 'styled-components';

export const SummaryCardsContainer = styled.div`
	display: flex;
	gap: 24px;
	flex-wrap: wrap;
	padding: 24px 0;
`;
